import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef,  NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { NewsArticle } from './news-article.model';
import { NewsArticlePopupService } from './news-article-popup.service';
import { NewsArticleService } from './news-article.service';
import { School, SchoolService } from '../school';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal, CRUD_ACTIONS } from '../../shared/index';
import { SERVER_DATE_TIME_FORMAT } from '../../shared/constants/date-time.constants';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-news-article-dialog',
    templateUrl: './news-article-dialog.component.html'
})
export class NewsArticleDialogComponent  extends AbstractDialogComponent implements OnInit {

    newsArticle: NewsArticle;
    authorities: any[];
    isSaving: boolean;
    validSince: NgbDateStruct;
    validUntil: NgbDateStruct;

    schools: School[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private newsArticleService: NewsArticleService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        private datePipe: DatePipe,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['newsArticle']);
    }

    ngOnInit() {

        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.validSince = this.toDateStruct(this.newsArticle.validSince);
        this.validUntil = this.toDateStruct(this.newsArticle.validUntil);
        this.loadSchools();
    }

    private toDateStruct (date: Date): NgbDateStruct {
        if ( date ) {

            if (!(date instanceof Date)) {
                date = new Date(date);
            }

            return {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate()
            };

        } else {
            let today: Date = new Date();
            return {
                year: today.getFullYear(),
                month: today.getMonth() + 1,
                day: today.getDate()
            };
        }
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {

        this.isSaving = true;
        // We add the time (HH:mm:ss) to both dates before saving.
        // The valid since date must use the 00:00:01 time
        let fromDate = new Date();
        fromDate.setDate(this.validSince.day);
        fromDate.setMonth(this.validSince.month - 1);
        fromDate.setFullYear(this.validSince.year);
        fromDate.setHours(0);
        fromDate.setMinutes(0);
        fromDate.setSeconds(1);

        // The valid until date use 23:59:59
        let toDate = new Date();
        toDate.setDate(this.validUntil.day);
        toDate.setMonth(this.validUntil.month - 1);
        toDate.setFullYear(this.validUntil.year);
        toDate.setHours(23);
        toDate.setMinutes(59);
        toDate.setSeconds(59);

        this.newsArticle.validSince = this.datePipe.transform(fromDate, SERVER_DATE_TIME_FORMAT);
        this.newsArticle.validUntil = this.datePipe.transform(toDate, SERVER_DATE_TIME_FORMAT);

        if (this.newsArticle.id !== undefined) {
            this.newsArticleService.update(this.newsArticle)
                .subscribe((res: NewsArticle) =>
                this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.newsArticleService.create(this.newsArticle)
                .subscribe((res: NewsArticle) =>
                this.onSaveSuccess(res, CRUD_ACTIONS.CREATE), (res: HttpErrorResponse) => this.onSaveError(res));
        }

    }

    private onSaveSuccess(result: NewsArticle, action: String) {
        this.eventManager.broadcast({ name: 'newsArticleListModification', content: {
            action: action,
            content: result
        }});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-news-article-popup',
    template: ''
})
export class NewsArticlePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private newsArticlePopupService: NewsArticlePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if ( params['id'] ) {
                this.modalRef = this.newsArticlePopupService
                    .open(NewsArticleDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.newsArticlePopupService
                    .open(NewsArticleDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/news-article/news-article-dialog.component.ts